import isBlockTextLight from './is-block-text-light';

const isBlockTextDark = (block) => !isBlockTextLight(block);

export default isBlockTextDark;
